<template>
  <modal :active="active" @close="closeModal" :title="title">
    <template slot="body">
      <div class="columns" v-if="loading">
        <div class="col-2 col-mx-auto p-t-20">
          <loading-spinner></loading-spinner>
        </div>
      </div>
      <div v-else>
        <v-row no-gutters v-if="mStep == 0">
          <v-col class="col-12">
            <revision-detail
              :request="cloned"
              :container="container"
              :customer="customer"
              :dealerId="dealerId"></revision-detail>
          </v-col>
          <v-col class="col-12 p-t-20">
            <v-row no-gutters>
              <v-col class="col-5 text-right">
                <button class="btn col-auto btn-success" @click="acceptAppointment()">
                  <i class="fas fa-angle-right"></i>
                  {{ $t('appointments.detail.accept-appointment') }}
                </button>
              </v-col>
              <v-col class="col-1"></v-col>
              <v-col class="col-5 text-left">
                <button class="btn col-auto btn-error" @click="rejectAppointment">
                  <i class="fas fa-angle-right"></i>
                  {{ $t('appointments.detail.delete-appointment') }}
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <revision-confirm v-if="mStep == 1" />
        <revision-delete v-if="mStep == 2" @confirm="confirmRejectAppointment" />
        <revision-delete-confirm v-if="mStep == 3" />
        <request-modified v-if="mStep == 4" />
        <error-message v-if="mStep == 5" />
      </div>
    </template>
  </modal>
</template>
<script>
import repairOrdersApi from '@/api/repairOrders.api'
import ErrorMessage from '@/components/dialog/ErrorMessage'
import RequestModified from '@/components/dialog/RequestModified'
import Modal from '@/components/Modal.vue'
import LoadingSpinner from '@/components/other/LoadingSpinner'
import {eventBus} from '@/main'

import RevisionConfirm from './RevisionConfirm'
import RevisionDelete from './RevisionDelete'
import RevisionDeleteConfirm from './RevisionDeleteConfirm'
import RevisionDetail from './RevisionDetail'

export default {
  name: 'RevisionModal',
  props: {
    active: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    request: {
      type: Object,
      default: null,
    },
    container: {
      type: Object,
      default: null,
    },
    customer: {
      type: Object,
      default: null,
    },
    dealerId: {
      type: String,
      default: null,
    },
    step: {
      type: Number,
      default: () => {
        return 0
      },
    },
  },
  components: {
    Modal,
    RevisionDetail,
    RevisionConfirm,
    RevisionDelete,
    RevisionDeleteConfirm,
    RequestModified,
    ErrorMessage,
    LoadingSpinner,
  },
  data() {
    let cloned = JSON.parse(JSON.stringify(this.request)) //TODO: Hack to avoid v-model aliasing with parent rowData;
    cloned.pickup = cloned.pickup || {day: null, hour: null}
    return {
      cloned,
      mStep: 0,
      loading: false,
    }
  },
  created() {
    this.mStep = this.step
  },
  computed: {
    title() {
      switch (this.mStep) {
        case 0:
          return this.$t('appointments.detail.title').toUpperCase()
        default:
          return ''
      }
    },
  },
  methods: {
    closeModal() {
      // Parent owns the list reload; emitting refresh-list here would double-fire load().
      this.emitClose()
    },
    emitClose() {
      eventBus.$emit('refresh-counters')
      this.$emit('closePopup')
    },
    filterTrueKeys(input) {
      return Object.entries(input)
        .filter(([_, value]) => value)
        .map(([key]) => key.toUpperCase())
    },
    async acceptAppointment() {
      const appointmentId = this.cloned.appointment.id

      const reason = this.filterTrueKeys(this.cloned.requested)
      if (this.cloned.requested.other && !reason.includes('OTHER')) {
        reason.push('OTHER')
      }

      const appointment = {
        petitionDate: this.cloned.appointment.day,
        petitionHour: this.cloned.appointment.hour,
        pickupDate: this.cloned.pickup && this.cloned.pickup.day,
        pickupHour: this.cloned.pickup && this.cloned.pickup.hour,
        reason,
        courtesyBikeStatus: this.cloned.courtesyBike.status,
        comment: this.comment,
        otherReason: this.cloned.requested.other || null,
      }

      if (!appointment.comment) {
        delete appointment.comment
      }

      if (!appointment.otherReason) {
        delete appointment.otherReason
      }

      if (!appointment.pickupDate) {
        delete appointment.pickupDate
      }

      if (!appointment.pickupHour) {
        delete appointment.pickupHour
      }

      this.loading = true

      await repairOrdersApi.acceptAppointment(appointmentId, appointment)
      this.loading = false
      this.mStep = 1
    },
    async confirmRejectAppointment() {
      const id = this.cloned.appointment.id
      this.loading = true

      await repairOrdersApi.cancelAppointment(id)
      this.loading = false
      this.mStep = 3
    },
    rejectAppointment() {
      this.mStep = 2
    },
  },
}
</script>
